import moment from "moment";

import DocumentType from "./DocumentType";
import { parseDate } from "../common/Hooks";
import { DocumentAttributes } from "../attributes/document-attributes";
import { DD_MM_YYYY_FORMAT, YYYY_MM_DD_FORMAT } from "../settings/constants";

class Document {
  paths: Array<string>;
  registration_key: string;
  expiration_date: Date | null;
  issue_date: Date | null;

  document_type: DocumentType;

  constructor(
    paths: Array<string>,
    registration_key: string,
    expiration_date: Date | null,
    issue_date: Date | null,
    document_type: DocumentType
  ) {
    this.paths = paths;
    this.registration_key = registration_key;
    this.expiration_date = expiration_date;
    this.issue_date = issue_date;
    this.document_type = document_type;
  }

  static fromJson(json: DocumentAttributes): Document {
    if (json === null || json === undefined) {
      return null;
    }

    return new Document(
      json.paths,
      json.registration_key,
      parseDate(json.expiration_date),
      parseDate(json.issue_date),
      DocumentType.fromJson(json.document_type)
    );
  }

  expirationDate = (): string => {
    if (this.expiration_date !== null) {
      return moment(this.expiration_date, YYYY_MM_DD_FORMAT).format(
        DD_MM_YYYY_FORMAT
      );
    }

    return "";
  };

  issueDate = (): string => {
    if (this.issue_date !== null) {
      return moment(this.issue_date, YYYY_MM_DD_FORMAT).format(
        DD_MM_YYYY_FORMAT
      );
    }

    return "";
  };
}

export default Document;
